import { useEffect, useState } from 'react';

/**
 * <video> wrapper that mirrors SafeImage's failure handling. On error (404, unsupported codec,
 * blocked CORS, etc.) the wrapper renders `fallback` (null by default — the video vanishes) and
 * invokes the parent's onError callback. Parents that show multiple media items (e.g. the
 * lightbox) use the callback to auto-skip past broken videos.
 *
 * No equivalent of SafeImage's `referrerPolicy` here: <video> doesn't honour the attribute, and
 * Google FIFE video URLs work without referrer fiddling.
 */
const SafeVideo = ({ src, onError, fallback = null, ...videoProps }) => {
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        setFailed(false);
    }, [src]);

    const handleError = e => {
        setFailed(true);
        onError?.(e);
    };

    if (failed) return fallback;

    return <video {...videoProps} src={src} onError={handleError} />;
};

export default SafeVideo;
